import { buildProps, definePropType } from '@ll-plus/utils'

import type { ExtractPropTypes } from 'vue'
import { IconProps } from '../../icon'
import { footerShadowPlacement } from '../../new-drawer'
import type ModalOverlay from './modal-overlay.vue'

export const modalOverlayProps = buildProps({
  open: {
    type: Boolean,
    required: true,
  },

  // 圆角
  borderRadius: {
    type: String,
    default: '6px',
  },

  // 根节点类名
  rootClass: {
    type: String,
    default: '',
  },

  // 层级
  zIndex: {
    type: Number,
    default: 1100,
  },

  // 是否显示关闭
  showClose: {
    type: Boolean,
    default: true,
  },

  // 是否显示头部
  showHeader: {
    type: Boolean,
    default: true,
  },
  // 关闭按钮样式
  closeStyle: {
    type: Object,
    default: () => ({}),
  },

  // 头部区样式
  headerStyle: {
    type: Object,
    default: () => ({}),
  },

  // 关闭按钮文本
  closeText: {
    type: String,
    default: '返回',
  },

  // 关闭文本颜色
  closeTextColor: {
    type: String,
    default: '#868e9a',
  },

  // 关闭文本大小
  closeTextSize: {
    type: Number,
    default: 14,
  },

  // 关闭图标
  closeIcon: {
    type: definePropType<IconProps>(Object),
    default: () => ({
      iconName: 'icon-return-arrow',
      color: undefined,
      size: undefined,
    }),
  },

  // 图标文本间距
  closeIconTextSpace: {
    type: Number,
    default: 8,
  },

  // 全屏loading
  fullLoading: {
    type: Boolean,
    default: false,
  },

  // 主内容区loading
  mainLoading: {
    type: Boolean,
    default: false,
  },

  // 主内容区类名
  mainClass: {
    type: String,
    default: '',
  },

  isBespreadMain: {
    type: Boolean,
    default: false,
  },

  // 主内容区样式
  mainStyle: {
    type: Object,
    default: () => ({}),
  },

  // 是否显示页脚
  showFooter: {
    type: Boolean,
    default: true,
  },

  // 页脚区样式
  footerStyle: {
    type: Object,
    default: () => ({}),
  },

  // 媒体查询类名
  mediaClass: String,

  /**
   * @description 滚动是否显示底部阴影
   */
  isShowFooterShadow: {
    type: Boolean,
    default: true,
  },
  /**
   * @description 决定底部阴影的方向(外部和内部）,默认由内容区域来决定
   */
  footerShadowPlacement: {
    type: String,
    values: footerShadowPlacement,
    default: 'inner',
  },
} as const)

export const modalOverlayEmits = {
  // 点击取消时触发
  close: (bool?: boolean) => typeof bool === 'boolean',

  // 关闭双向绑定
  'update:open': (bool?: boolean) => typeof bool === 'boolean',
} as const

// props
export type ModalOverlayProps = ExtractPropTypes<typeof modalOverlayProps>

// emits
export type ModalOverlayEmits = typeof modalOverlayEmits

// instance
export type ModalOverlayInstance = InstanceType<typeof ModalOverlay>
